// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__u4YCI","paymentContainer":"PaymentPage_paymentContainer__22pb5"};